var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"slice-project-image my-70 md_my-100 px-20"},[_c('project-image',{attrs:{"image":_vm.slice.image[0]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }